import { Button } from '@material-ui/core';
import _ from 'lodash';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCallbackOne } from 'use-memo-one';
import TableWithState from '../../components/TableWithState/TableWithState';
import { ETables } from '../../types/enums/ETables';
import { NSNotifications } from '../../types/interfaces/NSNotifications';
import { endpoints } from '../../utils/endpoints';
import tPaths from '../../utils/tPaths';
import useApi from '../../utils/useApi';
import useCellStatusStyleHandler from '../../utils/useCellStatusStyleHandler';
import useColumnsHeaders from '../../utils/useColumnsHeaders';
import useSnackbar from '../../utils/useSnackbar';

const tableName = ETables.InAppNotifications;

const InAppNotification = () => {
  const cellStyleHandler = useCellStatusStyleHandler();
  const { post } = useApi(null);
  const pushSnack = useSnackbar();
  const { t } = useTranslation();

  const [buttonsRegistry, setButtonsRegistry] = useState<Record<string, boolean>>({});

  const disableButton = useCallbackOne((id: string) => {
    setButtonsRegistry((v) => ({ ...v, [id]: true }));
  }, []);

  const enableButton = useCallbackOne((id: string) => {
    setButtonsRegistry((v) => ({ ...v, [id]: false }));
  }, []);

  const dataFormatter = useCallback(
    (dataTable: NSNotifications.ITableItem[]): any[] =>
      dataTable.map((table) => ({
        _id: table._id,
        title: table.title,
        body: table.body,
        action: () => (
          <Button
            onClick={(e) => (
              e.preventDefault(),
              post({
                endpoint: endpoints.sendNotification(table._id),
                onSuccess: () => (enableButton(table._id), pushSnack({ severity: 'success' })),
                onError: (res) => (
                  enableButton(table._id), pushSnack({ severity: 'error', message: res.response?.data.message })
                ),
              }),
              disableButton(table._id)
            )}
            color="primary"
            disabled={_.has(buttonsRegistry, table._id) ? buttonsRegistry[table._id] : false}
            style={{ height: 30 }}
            children={t(tPaths.table.send)}
          />
        ),
      })),
    [t, buttonsRegistry],
  );

  const columns = useColumnsHeaders([
    { accessorAsHeader: '_id' },
    { accessorAsHeader: 'title' },
    { accessorAsHeader: 'body' },
    { accessorAsHeader: 'action' },
  ]);

  return (
    <TableWithState
      tableName={tableName}
      dataFormatter={dataFormatter}
      cellStyleHandler={cellStyleHandler}
      columns={columns}
      refreshable={false}
      exportable={false}
      addable={true}
    />
  );
};

export default InAppNotification;
